import ActionButton from 'components/ActionButton';
import React, { useEffect, useState } from 'react';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { Error } from 'components/message/Error';
import { sendPushNotification } from 'services';
import ImageUploadComponent from 'components/ImageUploadComponent';
import { validateHttpsUrl } from 'utils/validations';

const IMAGE_TYPES = {
  URL: 'URL',
  FILE: 'FILE',
};

const validationSchema = yup.object().shape({
  title: yup.string().required('Title is required'),
  userId: yup.string().required('User id is required'),
  body: yup.string().required('Body is required'),
  imageUrl: yup.string().test('url-validation', 'Please enter a valid https url', async (value) => {
    console.log(validateHttpsUrl(value),value, 'validateHttpsUrl(value)');
    
    return validateHttpsUrl(value);
  }),
  data: yup
    .string()
    .test('data-validation', 'Please enter a valid JSON', async (value) => {
      try {
        JSON.parse(value || '{}');
      } catch (e) {
        return false;
      }
      return true;
    }),
});

type FormData = {
  title: string;
  userId: string;
  body: string;
  data: string;
  imageUrl: string;
};

const SendPushNotification = (props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [imageType, setImageType] = useState<string>(IMAGE_TYPES.URL);
  const { register, handleSubmit, errors, setValue } = useForm<FormData>({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    register('imageUrl');
  }, []);

  const handleSendPushNotification = handleSubmit(
    async ({ title, body, userId, data = '{}', imageUrl }) => {
      setLoading(true);
      try {
        await sendPushNotification({
          title,
          body,
          channel: `uc${userId}`,
          data: JSON.parse(data),
          imageUrl: imageUrl,
        });
        showSuccess('Notification sent successfully.');
        setValue('title', '');
        setValue('userId', '');
        setValue('body', '');
        setValue('data', '');
        setValue('imageUrl', '');
        // props.history.replace(`/users/${user.objectId}`);
      } catch (e) {
        showError(e);
      } finally {
        setLoading(false);
      }
    }
  );

  const onChangeImageType = (e) => {
    setImageType(e?.target?.value);
    setValue('imageUrl', '');
  };

  const getFileInput = () => {
    return (
      <div>
        <div style={{ display: imageType === IMAGE_TYPES.FILE ? 'none' : 'block' }}>
          <input
            name={'imageUrl'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
          {errors.imageUrl && <Error message={errors.imageUrl.message} />}
        </div>
        <div
          className={styles['image-container']}
          style={{ display: imageType === IMAGE_TYPES.URL ? 'none' : 'block' }}
        >
          <ImageUploadComponent
            src={''}
            uploadAPI={(entityId, file) => {
              // we are replacing http from https as we need https in image url in push notification
              const imageUrl = file?._url.replace('http', 'https');
              setValue('imageUrl', imageUrl);
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['header']}>
        <div className={styles['heading']}>Send Push Notification</div>
      </div>
      <div className={styles['user-details']}>
        <div
          className={
            'd-flex justify-content-between flex-column flex-lg-row flex-md-row'
          }
        >
          <div className={styles['userId']}>
            <div className={styles['label']}>User Id</div>
            <input
              name={'userId'}
              ref={register}
              className={'form-control'}
              disabled={loading}
            />
            {errors.userId && <Error message={errors.userId.message} />}
          </div>
          <div className={styles['title']}>
            <div className={styles['label']}>Title</div>
            <input
              name={'title'}
              ref={register}
              className={'form-control'}
              disabled={loading}
            />
            {errors.title && <Error message={errors.title.message} />}
          </div>
        </div>

        <div className={styles['body']}>
          <div className={styles['label']}>Body</div>
          <input
            name={'body'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
          {errors.body && <Error message={errors.body.message} />}
        </div>

        <div className={styles['data']}>
          <div className={styles['label']}>Data</div>
          <textarea
            name={'data'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
          {errors.data && <Error message={errors.data.message} />}
        </div>
        <div className={styles['label']}>Image</div>
        <div className="d-flex">
          <div className={`${styles['input-group']} d-flex align-items-center`}>
            <input
              type={'radio'}
              name={'image-type'}
              onChange={onChangeImageType}
              checked={imageType === IMAGE_TYPES.URL}
              value={IMAGE_TYPES.URL}
            />
            <div className="ml-2">Image Url</div>
          </div>
          <div
            className={`${styles['input-group']} d-flex align-items-center ml-4`}
          >
            <input
              type={'radio'}
              name={'image-type'}
              onChange={onChangeImageType}
              checked={imageType === IMAGE_TYPES.FILE}
              value={IMAGE_TYPES.FILE}
            />
            <div className="ml-2">Image File</div>
          </div>
        </div>
        {getFileInput()}
      </div>
      <div className={styles['footer']}>
        <ActionButton
          text={'Send'}
          active={!loading}
          isLoading={loading}
          onClick={handleSendPushNotification}
        />
      </div>
    </div>
  );
};

export default SendPushNotification;
